<mat-toolbar color="primary" fxFlex="0 0 100%" class="toolbar" [class.breadCrumbs]="shouldDisplay" fxLayout="column">
    <mat-toolbar-row class="top-row" fxFlex="1 0 120px" fxFlex.gt-xs="1 0 60px" fxLayoutGap="10px" fxLayout="row wrap">

        <button mat-button [routerLink]="['./']" fxFlex="0 0 50px" fxFlex.gt-sm="0 0 88px" fxFlexOrder="1"><mat-icon>home</mat-icon></button>

        <button mat-button class="app-dark-theme" [matMenuTriggerFor]="menu" fxFlex="0 0 50px" fxFlex.gt-sm="0 0 88px" fxFlexOrder="2"><mat-icon>apps</mat-icon></button>

        <mat-menu #menu="matMenu" class="menu-dropdown app-dark-theme" [overlapTrigger]="false">

            <mat-grid-list cols="2" rowHeight="2.5em" gutterSize="10" color="accent">
                <mat-grid-tile *ngFor="let category of topLevelCategories">
                    <button mat-menu-item [routerLink]="['/category', category.id]">

                        <span>{{category.title}}</span>
                      </button>
                </mat-grid-tile>
            </mat-grid-list>
        </mat-menu>

        <form class="searchForm" [formGroup]="searchForm" (ngSubmit)="onSubmit(searchForm)" fxFlex="1 0 340px" fxFlexOrder="8" fxFlexOrder.gt-xs="4">
            <mat-form-field class="app-dark-theme app-search-bar" fxFlex="1 0 340px" fxLayoutAlign="center center" floatLabel="never">
                <!-- <app-search-input placeholder="Enter a search term" formControlName="search"></app-search-input> -->
                <input type="text" fxFlex="1 0 auto" matInput class="term" placeholder="Enter a search term" formControlName="search" [matAutocomplete]="auto">
                <mat-icon matSuffix fxFlex="1 0 auto" class="search-icon-button" (click)="initiateSearch">search</mat-icon>
            </mat-form-field>

            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSubmit(searchForm)">
                <mat-option class="auto-option" *ngFor="let option of filteredOptions | async" [value]="option">
                    <span class="option-title">{{ option.title }} </span>
                    <span *ngIf="option.group_id || option.group_id==0" class="option-title-category">Category</span>
                    <span *ngIf="!option.group_id" class="option-title-category">In {{ option.category_name }}</span>
                </mat-option>
            </mat-autocomplete>
        </form>
        <button mat-button fxFlex="0 0 50px" fxHide.xs="TRUE" fxFlex.gt-sm="0 0 88px" fxFlexOrder="5"><a href="http://suplugins.com/podiumbrowser/help/pb-faq-v26.php" target="_blank"><mat-icon>help</mat-icon></a></button>

        <button mat-button fxFlex="0 0 50px" fxHide.xs="TRUE" fxFlex.gt-sm="0 0 88px" fxFlexOrder="6" (click)="reloadPage()"><mat-icon>refresh</mat-icon></button>


    </mat-toolbar-row>
    <mat-toolbar-row fxFlex="1 0 30px" class="breadcrumbs-row" *ngIf="shouldDisplay">

        <app-breadcrumbs [categories]="currentcategoryArray"></app-breadcrumbs>
    </mat-toolbar-row>

</mat-toolbar>



// WEBPACK FOOTER //
// ./src/app/tool-bar/tool-bar.component.html